// Turks (tr-TR), kamers: zelfde vorm als kamers.nl.ts. Wat ontbreekt valt terug op het Nederlands
// (nooit een rauwe sleutel op het scherm). Kiosk-teksten kort en eenvoudig voor kinderen.
export const kamersTr = {
    nav: {
        rooms: 'Odalar',
        cleaning: 'Temizlik',
        kidLock: 'Çocuk kilidi',
    },
    roomKind: {
        living: 'Oturma odası',
        bedroom: 'Yatak odası',
        utility: 'Çamaşır odası ya da dolap',
    },
    rooms: {
        title: 'Odalar',
        intro: 'Her tablet bir odaya aittir. Tablette kimi göreceğini oda belirler.',
        add: 'Oda',
        addTitle: 'Yeni oda',
        everyone: 'Herkes',
        tablets: { one: '{count} tablet', other: '{count} tablet' },
        noTablet: 'Henüz tablet yok',
        modeAgenda: 'Takvim ve görevler',
        modeLogboek: 'Temizlik dolabı',
        open: 'Aç',
        back: 'Odalar',
        name: 'Ad',
        nameHint: 'Örneğin: Yakub ve Ömer’in odası',
        kind: 'Oda türü',
        whoTitle: 'Bu tablette kimi görüyorsun?',
        whoIntro: 'Yatak odasındaki tablette sadece orada uyuyanları görürsün.',
        whoAll: 'Herkes',
        whoExplicit: 'Sadece odada kalanlar',
        residents: 'Odada kalanlar',
        residentsHint: 'Açmak ya da kapatmak için bir yüze dokun.',
        noResidentsWarning: 'Burada kimin uyuduğunu seç, yoksa tablet boş kalır.',
        noResidentsUtility: 'Kimse seçilmezse herkes bu tablette kendini seçebilir.',
        householdWide: 'Tüm ailenin etkinliklerini de göster',
        showTitle: 'Tablet ne gösteriyor?',
        showAgenda: 'Takvim ve görevler',
        showAgendaHint: 'Bugün, hafta ve görevlerle normal pano.',
        showLogboek: 'Temizlik dolabı',
        showLogboekHint: 'Büyük kutucuklar: çamaşırı kim yıkadı, süpürgeyi kim çekti.',
        a11yTitle: 'Tablette erişilebilirlik',
        readAloud: 'Sesli oku',
        readAloudHint: 'Bir resme dokun, tablet onu sesli okusun. Henüz okuma bilmeyenler için kullanışlı.',
        textSize: 'Yazı boyutu',
        textNormal: 'Normal',
        textLarge: 'Büyük',
        textFar: 'Çok büyük',
        calmMotion: 'Sakin hareket',
        calmMotionHint: 'Hareketli kutlamalar yok, her şey sessizce belirir.',
        sounds: 'Ses',
        tabletsTitle: 'Bu odadaki tabletler',
        tabletsEmpty: 'Burada henüz tablet yok.',
        moveHere: 'Tableti buraya taşı',
        moveChoose: 'Bir tablet seç',
        moved: '{name} artık burada: {room}.',
        lastSeen: 'son görülme {ago}',
        save: 'Kaydet',
        saved: 'Kaydedildi. Tablet bunu bir dakika içinde gösterir.',
        created: '{name} eklendi.',
        remove: 'Odayı sil',
        removeBlocked: 'Önce tableti başka bir odaya taşı.',
        removeTitle: 'Oda silinsin mi?',
        removeBody: '{name} kalkar. Geçmiş saklanır.',
        removeConfirm: 'Sil',
        removed: '{name} silindi.',
        lastRoom: 'Bir ailede en az bir oda kalmalı.',
        conflict: 'Bu odayı bu arada başka biri değiştirdi. En yeni hâlini yükledik.',
        emptyTitle: 'Her odaya kendi panosu',
        emptyBody: 'Yatak odasına ya da çamaşır odasına bir tablet as ve orada kimi göreceğini seç.',
        notFound: 'Bu oda yok (artık).',
    },
    cleaning: {
        title: 'Temizlik',
        add: 'İş',
        tabTurn: 'Sıra kimde',
        tabHistory: 'Geçmiş',
        tabItems: 'İşler',
        turnIntro: 'Bir işi en uzun süredir yapmayan kişinin sırası gelir.',
        status: { fresh: 'Yeni yapıldı', soon: 'Yakında', due: 'Zamanı geldi' },
        every: { one: 'her gün', other: '{count} günde bir' },
        everyWeek: 'her hafta',
        every2Weeks: 'iki haftada bir',
        everyMonth: 'her ay',
        lastBy: 'Son: {name}, {when}',
        never: 'Hiç yapılmadı',
        turn: 'Sıra onda',
        doneAction: 'Yapıldı…',
        doneTitle: '{item} yapıldı',
        who: 'Kim',
        when: 'Ne zaman',
        time: 'Saat',
        whenHint: '30 güne kadar geriye alınabilir.',
        note: 'Not',
        logged: '{item}: yapan {name}.',
        loggedNoPoints: 'Kaydedildi. Puan yok: {name} bunu zaten yaptı ({when}).',
        points: { one: '{count} yıldız', other: '{count} yıldız' },
        alreadyBy: 'zaten yapan: {name}',
        deleted: 'silindi',
        source: { kiosk: 'tablette', app: 'uygulamada' },
        removeLog: 'Sil',
        removeLogTitle: 'Bu kayıt silinsin mi?',
        removeLogBody: '{name} puanları artık almaz.',
        removeLogConfirm: 'Sil',
        logRemoved: 'Silindi.',
        negativeTitle: 'Bakiye eksiye düşüyor',
        negativeBody: '{name} puanları zaten harcadı. Yine de silinsin mi?',
        historyEmptyTitle: 'Henüz hiçbir şey yapılmadı',
        historyEmptyBody: 'Biri bir şey kaydeder etmez burada görürsün.',
        filterAll: 'Herkes',
        filterLabel: 'Üyeye göre süz',
        showDeleted: 'Silinenleri de göster',
        today: 'Bugün',
        yesterday: 'Dün',
        itemsIntro: 'Her yer için işler ve ne sıklıkla tekrarlandıkları.',
        noLocation: 'Yeri yok',
        edit: 'Düzenle',
        archive: 'Kaldır',
        archived: '{name} kaldırıldı.',
        editorNew: 'Yeni iş',
        editorEdit: 'İşi düzenle',
        itemName: 'Ad',
        itemNameHint: 'Kısa ve net, örneğin: Çamaşır makinesini çalıştır',
        icon: 'Simge',
        location: 'Yer',
        newLocation: 'Yeni yer…',
        newLocationName: 'Yerin adı',
        howOften: 'Ne sıklıkla',
        customDays: 'Gün sayısı',
        pointsLabel: 'Puan',
        pointsHint: 'Birden fazla kişi yapsa da her dönemde en fazla bir kez.',
        participants: 'Kimler katılıyor',
        participantsHint: 'Kimse seçilmezse herkes.',
        saved: 'Kaydedildi.',
        conflict: 'Bu iş bu arada değiştirildi. En yeni hâlini yükledik.',
        emptyTitle: 'Henüz temizlik işi yok',
        emptyBody: 'Çamaşır makinesi gibi sık tekrarlanan bir şeyle başla.',
        emptyAction: 'İş ekle',
        suggestions: 'Ya da bir örnekle başla',
        suggest: {
            laundry: 'Çamaşır makinesini çalıştır',
            hang: 'Çamaşırları as',
            bath: 'Banyoyu temizle',
            vacuum: 'Süpürge çek',
            plants: 'Çiçekleri sula',
        },
        loadError: 'Bir şeyler ters gitti. Tekrar dene.',
        retry: 'Tekrar dene',
    },
    kidLock: {
        title: 'Çocuk kilidi',
        intro: 'Kardeşler birbirinin görevlerini işaretliyorsa kullanışlı. Varsayılan olarak kapalı; kilit sadece tablette geçerli.',
        none: 'Kilit yok',
        pin: 'PIN kodu',
        picture: 'Resimli kod',
        since: '{when} tarihinden beri',
        waiting: '{time} saatine kadar bekliyor',
        set: 'Ayarla',
        change: 'Değiştir',
        sheetTitle: 'Çocuk kilidi: {name}',
        kindLabel: 'Kilit türü',
        noneHint: 'Herkes tablette {name} için dokunabilir.',
        pinHint: '{name} için akılda kalacak 4 rakam.',
        pictureHint: 'Sırayla 4 resim. Resimleri kendisi seçsin: {name}.',
        pinLabel: 'PIN kodu (4 rakam)',
        pinRepeat: 'Bir kez daha',
        pinMismatch: 'İki PIN kodu aynı değil.',
        pinInvalid: 'Tam 4 rakam seç.',
        pictureChosen: 'Seçilen: {count}/4',
        pictureClear: 'Sil',
        pictureInvalid: '4 resim seç.',
        pictureSlot: 'Resim {n}',
        saved: 'Çocuk kilidi değiştirildi: {name}.',
        removed: 'Çocuk kilidi kapalı: {name}.',
        emptyTitle: 'Henüz çocuk yok',
        emptyBody: 'Önce çocuklarını Aile bölümünden ekle.',
        about: 'Unutuldu mu? Buradan yeni bir kod belirle. Tablette beş kez yanlış girilirse biraz beklemek gerekir.',
    },
    picture: {
        fox: 'Tilki',
        cat: 'Kedi',
        rabbit: 'Tavşan',
        bear: 'Ayı',
        panda: 'Panda',
        owl: 'Baykuş',
        lion: 'Aslan',
        frog: 'Kurbağa',
        turtle: 'Kaplumbağa',
    },
    voice: {
        dictate: 'Sesle yaz',
        listening: 'Dinliyorum…',
        stop: 'Durdur',
        heard: 'Duyduğum: {text}',
        failed: 'Bunu anlayamadım. Yazarak dene.',
    },
    kiosk: {
        entry: 'Temizlik',
        title: 'Temizlik dolabı',
        back: 'Geri',
        who: 'Kim yaptı?',
        hold: 'Daire dolana kadar yüzüne basılı tut',
        holdShort: 'Basılı tut',
        status: { fresh: 'Yeni yapıldı', soon: 'Yakında', due: 'Zamanı geldi' },
        never: 'hiç yapılmadı',
        justNow: 'az önce',
        minutesAgo: { one: '{count} dk önce', other: '{count} dk önce' },
        hoursAgo: { one: '{count} saat önce', other: '{count} saat önce' },
        daysAgo: { one: '1 gün önce', other: '{count} gün önce' },
        goodJob: 'Aferin, {name}!',
        /** Rustig, buiten het thema Kinderen (geen lof, geen sterren). */
        goodJobCalm: '{name} yaptı',
        stars: { one: '+{count} yıldız', other: '+{count} yıldız' },
        alreadyDone: 'Bunu {name} saat {time} yaptı. Yine de teşekkürler!',
        alreadyDoneCalm: 'Bunu {name} saat {time} yaptı.',
        oops: 'Hay aksi',
        undone: 'Geri alındı',
        other: 'Başka…',
        otherTitle: 'Ne yaptın?',
        sayIt: 'Söyle bakalım',
        emptyTitle: 'Henüz iş yok',
        emptyBody: 'Annen ya da baban uygulamadan hazırlar.',
        notSaved: 'Henüz kaydedilmedi, birazdan tekrar deneyeceğiz.',
        close: 'Kapat',
        lockAskPin: '{name}, kodun ne?',
        lockAskPicture: '{name}, hangi resimler?',
        lockWrong: 'Bir kez daha',
        lockWait: 'Biraz bekle…',
        lockDigit: 'Rakam {digit}',
        lockErase: 'Sil',
        lockProgress: '{count}/4',
        adhoc: {
            windows: 'Cam sil',
            sweep: 'Yeri süpür',
            trash: 'Çöpü çıkar',
            dishes: 'Bulaşık yıka',
            'tidy-up': 'Toparla',
            'water-plants': 'Çiçekleri sula',
            recycling: 'Cam ve kâğıt',
            'make-bed': 'Çarşafı değiştir',
        },
    },
    speech: {
        at: 'saat {time}',
        points: { one: '{count} yıldız', other: '{count} yıldız' },
    },
    a11y: {
        skipToContent: 'İçeriğe geç',
        mainNav: 'Ana menü',
    },
};
//# sourceMappingURL=kamers.tr.js.map